import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d2081690")

_pushScopeId("data-v-d2081690")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row sticky-wrapper" }
const _hoisted_3 = { class: "col-lg-8 col-md-8 padding-right-30" }
const _hoisted_4 = {
  id: "titlebar",
  class: "listing-titlebar"
}
const _hoisted_5 = { class: "listing-titlebar-title" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "listing-tag" }, "Eat & Drink", -1)
const _hoisted_7 = {
  href: "#listing-location",
  class: "listing-address"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-map-marker" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "star-rating",
  "data-rating": "5"
}, [
  /*#__PURE__*/_createVNode("div", { class: "rating-counter" }, [
    /*#__PURE__*/_createVNode("a", { href: "#listing-reviews" }, "(31 reviews)")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  id: "listing-nav",
  class: "listing-nav-container"
}, [
  /*#__PURE__*/_createVNode("ul", { class: "listing-nav" }, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("a", { class: "active" }, "Overview")
    ])
  ])
], -1)
const _hoisted_11 = {
  id: "listing-overview",
  class: "listing-section"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, " Ut euismod ultricies sollicitudin. Curabitur sed dapibus nulla. Nulla eget iaculis lectus. Mauris ac maximus neque. Nam in mauris quis libero sodales eleifend. Morbi varius, nulla sit amet rutrum elementum, est elit finibus tellus, ut tristique elit risus at metus. ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in pulvinar neque. Nulla finibus lobortis pulvinar. Donec a consectetur nulla. Nulla posuere sapien vitae lectus suscipit, et pulvinar nisi tincidunt. Aliquam erat volutpat. Curabitur convallis fringilla diam sed aliquam. Sed tempor iaculis massa faucibus feugiat. In fermentum facilisis massa, a consequat purus viverra. ", -1)
const _hoisted_14 = { class: "listing-links-container" }
const _hoisted_15 = { class: "listing-links contact-links" }
const _hoisted_16 = {
  href: "tel:12-345-678",
  class: "listing-links"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-phone" }, null, -1)
const _hoisted_18 = {
  href: "mailto:mail@example.com",
  class: "listing-links"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-envelope-o" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    target: "_blank",
    class: "listing-links"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-link" }),
    /*#__PURE__*/_createTextVNode(" www.example.com")
  ])
], -1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"clearfix\" data-v-d2081690></div><ul class=\"listing-links\" data-v-d2081690><li data-v-d2081690><a href=\"#\" target=\"_blank\" class=\"listing-links-fb\" data-v-d2081690><i class=\"fa fa-facebook-square\" data-v-d2081690></i> Facebook</a></li><li data-v-d2081690><a href=\"#\" target=\"_blank\" class=\"listing-links-yt\" data-v-d2081690><i class=\"fa fa-youtube-play\" data-v-d2081690></i> YouTube</a></li><li data-v-d2081690><a href=\"#\" target=\"_blank\" class=\"listing-links-ig\" data-v-d2081690><i class=\"fa fa-instagram\" data-v-d2081690></i> Instagram</a></li><li data-v-d2081690><a href=\"#\" target=\"_blank\" class=\"listing-links-tt\" data-v-d2081690><i class=\"fa fa-twitter\" data-v-d2081690></i> Twitter</a></li></ul><div class=\"clearfix\" data-v-d2081690></div>", 3)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "clearfix" }, null, -1)
const _hoisted_25 = { class: "col-lg-4 col-md-4 margin-top-75 sticky" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Slide = _resolveComponent("Slide")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Pagination = _resolveComponent("Pagination")
  const _component_Carousel = _resolveComponent("Carousel")
  const _component_Marker = _resolveComponent("Marker")
  const _component_GoogleMap = _resolveComponent("GoogleMap")
  const _component_Booking = _resolveComponent("Booking")
  const _component_OpeningHours = _resolveComponent("OpeningHours")
  const _component_PlaceContact = _resolveComponent("PlaceContact")
  const _component_ShareLike = _resolveComponent("ShareLike")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.place.images)
      ? (_openBlock(), _createBlock(_component_Carousel, {
          key: 0,
          "items-to-show": 3,
          "current-slide": 0,
          "wrap-around": true
        }, {
          slides: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.place.images, (image) => {
              return (_openBlock(), _createBlock(_component_Slide, { key: image }, {
                default: _withId(() => [
                  _createVNode("img", {
                    src: image.name,
                    class: "item",
                    title: image.name
                  }, null, 8, ["src", "title"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          addons: _withId(({ slidesCount }) => [
            (slidesCount > 3)
              ? (_openBlock(), _createBlock(_component_Navigation, { key: 0 }))
              : _createCommentVNode("", true),
            (slidesCount > 3)
              ? (_openBlock(), _createBlock(_component_Pagination, { key: 1 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h2", null, [
              _createTextVNode(_toDisplayString(_ctx.place.name) + " ", 1),
              _hoisted_6
            ]),
            _createVNode("span", null, [
              _createVNode("a", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.place.address.addressLine1) + ", " + _toDisplayString(_ctx.place.address.city), 1)
              ])
            ]),
            _hoisted_9
          ])
        ]),
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode("ul", _hoisted_15, [
              _createVNode("li", null, [
                _createVNode("a", _hoisted_16, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.place.phoneNumber), 1)
                ])
              ]),
              _createVNode("li", null, [
                _createVNode("a", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.place.email), 1)
                ])
              ]),
              _hoisted_20
            ]),
            _hoisted_21
          ]),
          _hoisted_24,
          _createVNode(_component_GoogleMap, {
            "api-key": "AIzaSyBOk6-X0sX7-0LSgz0-mBRAd87oIJr8Tyc",
            style: {"width":"100%","height":"500px","margin-top":"20px"},
            center: _ctx.center,
            zoom: 15
          }, {
            default: _withId(() => [
              _createVNode(_component_Marker, {
                options: { position: _ctx.center }
              }, null, 8, ["options"])
            ]),
            _: 1
          }, 8, ["center"])
        ])
      ]),
      _createVNode("div", _hoisted_25, [
        _createVNode(_component_Booking, { place: _ctx.place }, null, 8, ["place"]),
        _createVNode(_component_OpeningHours, { place: _ctx.place }, null, 8, ["place"]),
        _createVNode(_component_PlaceContact, { place: _ctx.place }, null, 8, ["place"]),
        _createVNode(_component_ShareLike, { place: _ctx.place }, null, 8, ["place"])
      ])
    ])
  ]))
})